<template>
	<a :href="downloadLink" class="btn btn--color" @click="sendForm">Выгрузить статистику</a>
</template>
<script>
import { useToast } from "vue-toastification";
import { mapGetters  } from "vuex";

export default {
	name: "StatsUpload",
	data() {
		return {
			toast: useToast(),
		}
	},
	computed: {
		downloadLink() {
            return `${window?.location?.origin}/api/tenders/stats/export/excel/${this.supplierFilter.dateFrom ? `?dateFrom=${this.supplierFilter.dateFrom}&dateTo=${this.supplierFilter.dateTo}` : ''}`
		},
		...mapGetters({
			supplierFilter: 'stats/getSupplierFilter',
		})
	},


}
</script>


